<!--根组件-->
<template>
  <div id="app" name="app">
    <el-container>
      <!-- 顶部导航栏 -->
      <div class="topbar">
        <div class="nav">
          <ul>
            <li v-if="!this.$store.getters.getUser">
              <el-button type="text" @click="login">登录</el-button>
              <span class="sep">|</span>
              <el-button type="text" @click="register = true">注册</el-button>
            </li>
            <li v-else>
              欢迎
              <el-popover placement="top" width="180" v-model="visible">
                <p>确定退出登录吗？</p>
                <div style="text-align: right; margin: 10px 0 0">
                  <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="logout">确定</el-button>
                </div>
                <el-button type="text" slot="reference">{{this.$store.getters.getUser.name}}</el-button>
              </el-popover>
            </li>
            <li>
              <router-link to="/order">我的订单</router-link>
            </li>
            <li>
              <router-link to="/collect">我的收藏</router-link>
            </li>
            <li :class="getNum > 0 ? 'shopCart-full' : 'shopCart'">
              <router-link to="/shoppingCart">
                <i class="el-icon-shopping-cart-full"></i> 购物车
                <span class="num">({{getNum}})</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- 顶部导航栏END -->

      <!-- 顶栏容器 -->
      <el-header>
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#409eff"
          router
        >
          <div class="logo">
            <router-link to="/mall">
              <img src="./assets/imgs/logo2.png" style="height: 55px" alt />
            </router-link>
          </div>
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/atHome">居家养老</el-menu-item>
<!--          <el-menu-item index="/experience">项目体验</el-menu-item>-->
          <el-menu-item index="/addNurse">成为护工</el-menu-item>
          <el-menu-item index="/mall">商品首页</el-menu-item>
          <el-menu-item index="/goods">全部商品</el-menu-item>
          <el-menu-item index="/about">关于我们</el-menu-item>

          <div class="so">
            <el-input placeholder="请输入搜索内容" v-model="search">
              <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
            </el-input>
          </div>
        </el-menu>
      </el-header>
      <!-- 顶栏容器END -->

      <!-- 登录模块 -->
      <MyLogin></MyLogin>
      <!-- 注册模块 -->
      <MyRegister :register="register" @fromChild="isRegister"></MyRegister>
      <!-- 主要区域容器 -->
      <router-view/>
      <Linkes></Linkes>
      <!-- 底栏容器 -->
      <el-footer>
        <div class="footer">
          <div class="row" style="padding-top: 20px;">
            <div class="col one">
              <div class="row">
                <ul>
                  <li><a href="">关于我们</a></li>
                  <li><a href="">更多资讯</a></li>
                  <li><a href="">养老服务</a></li>
                </ul>
                <ul>
                  <li><a href="">本院环境</a></li>
                  <li><a href="">成为护工</a></li>
                  <li><a href="">联系我们</a></li>
                </ul>
              </div>
            </div>
            <div class="col two">
              <h5>本院地址:西藏自治区拉萨市日光城养老之家</h5>
              <h5>联系电话: 12345678910</h5>
              <h5>地址邮箱: 123456789@qq.com</h5>
              <!--                <div style="width:300px;margin:0 auto; padding:20px 0;">-->
              <!--                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=54010202000366" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">藏公网安备 54010202000366号</p></a>-->
              <!--                </div>-->
              <h5><img src="https://grain-120.oss-cn-beijing.aliyuncs.com/%E5%9B%BD%E5%BE%BD.png" alt=""><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=54010202000366" target="_blank"> 藏公网安备 54010202000366号</a></h5>
              <h5><a href="https://beian.miit.gov.cn" target="_blank"> 陇ICP备2021001444号-1</a></h5>
              <h5>版权所有©乐花生信息科技有限责任公司</h5>
            </div>
            <div class="col three">
              <h5>联系我们:</h5>
              <a href="">
                <img src="https://grain-120.oss-cn-beijing.aliyuncs.com/friend03.gif" alt="" width="50px" data-toggle="tooltip" data-placement="bottom"
                     title="关注微信">
                <img src="https://grain-120.oss-cn-beijing.aliyuncs.com/friend05.gif" alt="" width="50px" data-toggle="tooltip" data-placement="bottom"
                     title="关注微博">
              </a>
            </div>
          </div>
        </div>
      </el-footer>
      <!-- 底栏容器END -->
    </el-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Linkes from './components/Linkes'

export default {
  name: 'App',
  components: {Linkes},
  beforeUpdate () {
    this.activeIndex = this.$route.path
  },
  data () {
    return {
      activeIndex: '', // 头部导航栏选中的标签
      search: '', // 搜索条件
      register: false, // 是否显示注册组件
      visible: false // 是否退出登录
    }
  },
  created () {
    // 获取浏览器localStorage，判断用户是否已经登录
    if (localStorage.getItem('user')) {
      // 如果已经登录，设置vuex登录状态
      this.setUser(JSON.parse(localStorage.getItem('user')))
    }
  },
  computed: {
    ...mapGetters(['getUser', 'getNum'])
  },
  watch: {
    // 获取vuex的登录状态
    getUser: function (val) {
      if (val === '') {
        // 用户没有登录
        this.setShoppingCart([])
      } else {
        // 用户已经登录,获取该用户的购物车信息
        this.$axios.get(`/vueback/shopCart/getShopCartByUserId/${val.id}`)
          .then(res => {
            console.log('购物车信息')
            console.log(res)
            console.log(res.data)
            if (res.data.code === 20000) {
              // 001 为成功, 更新vuex购物车状态
              console.log('购物车信息')
              this.setShoppingCart(res.data.data.items)
            } else {
              // 提示失败信息
              this.notifyError(res.data.data.msg)
            }
          })
          .catch(err => {
            return Promise.reject(err)
          })
      }
    }
  },
  methods: {
    ...mapActions(['setUser', 'setShowLogin', 'setShoppingCart']),
    login () {
      // 点击登录按钮, 通过更改vuex的showLogin值显示登录组件
      this.setShowLogin(true)
    },
    // 退出登录
    logout () {
      this.visible = false
      // 清空本地登录信息
      localStorage.setItem('user', '')
      // 清空vuex登录信息
      this.setUser('')
      this.notifySucceed('成功退出登录')
    },
    // 接收注册子组件传过来的数据
    isRegister (val) {
      this.register = val
    },
    // 点击搜索按钮
    searchClick () {
      if (this.search !== '') {
        // 跳转到全部商品页面,并传递搜索条件
        this.$router.push({ path: '/goods', query: { search: this.search } })
        this.search = ''
      }
    }
  }

}
</script>

<style>
/* 全局CSS */
* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;
}
#app .el-header {
  padding: 0;
}
#app .el-main {
  min-height: 300px;
  padding: 20px 0;
}
#app .el-footer {
  padding: 0;
}
a,
a:hover {
  text-decoration: none;
}
/* 全局CSS END */

/* 顶部导航栏CSS */
.topbar {
  height: 40px;
  background-color: #3d3d3d;
  margin-bottom: 20px;
}
.topbar .nav {
  width: 1225px;
  margin: 0 auto;
}
.topbar .nav ul {
  float: right;
}
.topbar .nav li {
  float: left;
  height: 40px;
  color: #b0b0b0;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  margin-left: 20px;
}
.topbar .nav .sep {
  color: #b0b0b0;
  font-size: 12px;
  margin: 0 5px;
}
.topbar .nav li .el-button {
  color: #b0b0b0;
}
.topbar .nav .el-button:hover {
  color: #fff;
}
.topbar .nav li a {
  color: #b0b0b0;
}
.topbar .nav a:hover {
  color: #fff;
}
.topbar .nav .shopCart {
  width: 120px;
  background: #424242;
}
.topbar .nav .shopCart:hover {
  background: #fff;
}
.topbar .nav .shopCart:hover a {
  color: #ff6700;
}
.topbar .nav .shopCart-full {
  width: 120px;
  background: #ff6700;
}
.topbar .nav .shopCart-full a {
  color: white;
}
/* 顶部导航栏CSS END */

/* 顶栏容器CSS */
.el-header .el-menu {
  max-width: 1225px;
  margin: 0 auto;
}
.el-header .logo {
  height: 55px;
  width: 200px;
  float: left;
  /*margin-right: 50px;*/
}
.el-header .so {
  margin-top: 10px;
  width: 300px;
  float: right;
}
/* 顶栏容器CSS END */

/* 底栏容器CSS */
.footer {
  width: 100%;
  text-align: center;
  color: #fff;
  background: #2f2f2f;
  padding-bottom: 20px;
}
.footer .row {
  display: flex;
  line-height: 30px;
}
.footer .row .col {
  width: 33%;
  margin: 0 auto;
  line-height: 30px;
}
.footer .row .one {
  font-size: 20px;
  display:flex;
  justify-content: center;
  align-items:center;
  padding-top: 10px;
}
.footer .row .one ul {
  /*height: 120px;*/
  line-height: 40px;
  margin: 0 10px;
}
.footer .row .one ul li a {
  color: #fff;
}
.footer .row h5 {
  font-weight: normal;
  font-size: 16px;
}
.footer .row .two {
  border-left: 1px solid #fff;
  border-right: 1px solid #fff;
}
.footer .row .three {
  padding: 40px 0;
}
/* 底栏容器CSS END */
</style>



// WEBPACK FOOTER //
// src/App.vue